export class CustomerUpdate {
    constructor(public AccountId: number, public CustomerType: string, public FieldName: string, public FieldValue: string) { }
}